import { useEffect } from 'react'
import { useStyletron } from 'baseui'

const PAGE_BACKGROUND_VARIABLE = '--hop-page-background'

const usePageBackground = (enabled: boolean) => {
  const [, theme] = useStyletron()
  const color = theme.colors.primaryPulse

  useEffect(() => {
    const root = document.documentElement.style
    if (!enabled) {
      root.removeProperty(PAGE_BACKGROUND_VARIABLE)
      return
    }
    root.setProperty(PAGE_BACKGROUND_VARIABLE, color)
  }, [enabled, color])
}

export default usePageBackground
